module.exports = __webpack_public_path__ + "static/media/sunglasses.317ad6c6.png";